import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TdDialogService } from '@covalent/core/dialogs';
import { Subject } from 'rxjs';
import { PilotHttpClient } from 'src/app/shared/flight-log-api/pilots/pilot-client.service';
import {
  CommandError,
  CommandResult,
  CommandResultStatus,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { PilotEntity } from 'src/store/pilot/pilot.model';
import { sleep } from 'src/util/async';
import { PrdProcessingState } from 'src/view-models/pilot-view-model';
import { PilotFormComponent } from '../pilot-form/pilot-form.component';

@Component({
  selector: 'fl-pilot-manage',
  templateUrl: './pilot-manage.component.html',
  styleUrls: ['./pilot-manage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotManageComponent implements OnInit, AfterViewInit {
  @Input()
  public pilot: PilotEntity;

  @ViewChild(PilotFormComponent)
  public formCmp: PilotFormComponent;
  public transmissionInProgress = false;
  public errors$: Subject<CommandError[]> = new Subject<CommandError[]>();

  constructor(
    private _pilot: PilotHttpClient,
    private _route: ActivatedRoute,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBar: MatSnackBar,
  ) {}

  public ngOnInit() {}

  public ngAfterViewInit() {
    this.transmissionInProgress =
      this.formCmp?.pilot?.processingState === PrdProcessingState.TransmissionInProgress
        ? true
        : false;
  }

  public async update() {
    const result = (await this._pilot
      .update(this.formCmp.form.getRawValue())
      .toPromise()) as CommandResult;
    if (result.errors.length > 0) {
      this._snackBar.open('Error updating pilot.', undefined, {
        duration: 2000,
      });
      this.errors$.next(result.errors);
    }

    if (result.errors.length === 0 && result.status === CommandResultStatus.Succeeded) {
      this._snackBar.open('Succesfully updated pilot.', undefined, {
        duration: 2000,
      });
      return this._router.navigate(['..'], {
        relativeTo: this._route,
      });
    }
  }

  public async delete() {
    const result = await this._dialogService
      .openConfirm({
        title: 'Delete Pilot?',
        message: 'Are you sure you wish to delete this pilot?',
        acceptButton: 'Delete',
        cancelButton: 'Cancel',
      })
      .afterClosed()
      .toPromise();
    if (result === true) {
      try {
        await this._pilot.delete(this.pilot.id).toPromise();
        await sleep(2000);
        this._snackBar.open('Succesfully deleted pilot.', undefined, {
          duration: 2000,
        });
        return this._router.navigate(['../../'], {
          relativeTo: this._route,
        });
      } catch (err) {
        this._snackBar.open('Error deleting pilot.', undefined, {
          duration: 2000,
        });

        throw err;
      }
    }
  }
}
